// extracted by mini-css-extract-plugin
export default {"contentCell":"Game__contentCell___WJr8X2RS"};